import { gql } from "@apollo/client";

export default gql`
  query aiSkillsOverview($organizationId: Int) {
    aiSkillsOverview(organizationId: $organizationId) {
      __typename
      ... on SkillNode {
        id
        name
        slug
        description
        body
        visibility
        canEdit
        canArchive
        isScheduled
      }
      ... on PlatformSkillType {
        platformId: id
        name
        slug
        description
        body
        visibility
        canEdit
        canArchive
        isScheduled
      }
    }
  }
`;
